import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import jstz from 'jstz';

const zone = momentTimeZone().tz(jstz.determine().name()).format('Z').replace('+', '%2B');
const start = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
const end = moment().format('YYYY-MM-DD HH:mm:ss');

export default function (lineId) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_UTILIZATION_RATE',
    manual: true,
  });

  useEffect(() => {
    if (lineId) {
      let url = `/api/worklines/${lineId}/group/utilization_rate_overview?start=${start}${zone}&end=${end}${zone}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineId]);

  return data;
}
